// Every user-visible string in the app lives here (spec: Thai UI copy, never inline in HTML/JS).
// Sentences that two maps share (an issue line and the error code of the same fault) are written once.
const ART_GONE = 'รูปละเอียดเกินไปสำหรับขนาดนี้ — ขยายรูปให้ใหญ่ขึ้น';
const BASE_PIECES = 'ชิ้นส่วนบนป้ายอยู่ห่างกันเกินไป ฐานยึดไว้ไม่ได้ — เพิ่มขอบฐาน ลดระยะห่าง หรือย่อรูปให้เล็กลง';
const INTERNAL = 'เกิดข้อผิดพลาด — ลองอีกครั้ง';
const FATAL = 'โหลดตัวสร้างโมเดลไม่สำเร็จ — รีเฟรชหน้า';
const S = {
  title: "ป้ายชื่อ 4 ชั้น",
  cap: "ความสูงตัวอักษร (มม.)",
  spacing: "ระยะห่างตัวอักษร",
  textHint: "กด Enter เพื่อขึ้นบรรทัดใหม่ · ได้ถึง 3 บรรทัด",
  dir: {
    h: "แนวนอน",
    v: "แนวตั้ง",
  },
  align: {
    h: {
      start: "ชิดซ้าย",
      center: "กึ่งกลาง",
      end: "ชิดขวา",
    },
    v: {
      start: "ชิดบน",
      center: "กึ่งกลาง",
      end: "ชิดล่าง",
    },
  },
  lineGap: "ระยะห่างบรรทัด",
  layers: "ชั้นสี",
  layerCount: "จำนวนชั้น",
  base: "ฐาน",
  ring: "ขอบ",
  textLayer: "ตัวอักษร",
  width: "กว้าง",
  height: "หนา",
  mm: " มม.",
  looks: "ชุดสี",
  loop: "ห่วงพวงกุญแจ",
  pos: {
    none: "ไม่มี",
    left: "ซ้าย",
    right: "ขวา",
    top: "บน",
  },
  hole: "รูกว้าง",
  ringW: "ขอบห่วง",
  print: "การพิมพ์",
  layerHeight: "ความหนาชั้นพิมพ์",
  mode: {
    multi: "หลายสี (CFS / AMS)",
    swap: "หัวเดียว เปลี่ยนสีตามชั้น",
  },
  zTable: (color, z, layer) => `เปลี่ยนเป็นสี ${color} ที่ ${z.toFixed(2)} มม. (ชั้นที่ ${layer})`,
  size: (w, h, z) => `${w.toFixed(1)} × ${h.toFixed(1)} × ${z.toFixed(1)} มม.`,
  dlstl: "ดาวน์โหลด STL",
  copied: "คัดลอกแล้ว",
  stillBuilding: "ยังสร้างแบบอยู่ — ข้อความขนาดใหญ่หลายบรรทัดอาจใช้เวลาราวหนึ่งนาที",
  loadingFont: (got, total) => `กำลังโหลดฟอนต์ ${got.toFixed(1)} / ${total.toFixed(1)} MB`,
  notice: {
    loadFailed: (family) => `โหลดฟอนต์ ${family} ไม่ได้ — ตรวจการเชื่อมต่อ · ใช้ฟอนต์เดิมต่อ`,
    capRaised: (family, cap) => `ปรับความสูงตัวอักษรเป็น ${cap} มม. — ขนาดเล็กสุดที่ฟอนต์ ${family} พิมพ์ได้ชัด`,
  },
  issue: {
    "missing-glyph": p => `ฟอนต์ ${String(p.font).replace(/@\d+$/, '')} ไม่มีตัวอักษร: ${p.chars.join(' ')}`,
    "thin-ring": p => `ขอบชั้นที่ ${p.band + 1} บางเกินไป (${p.w} มม.) — ควร ≥ 0.8 มม.`,
    "thin-stroke": p => p.minCap
      ? `ฟอนต์นี้พิมพ์ชัดตั้งแต่ ${p.minCap} มม. — เพิ่มความสูงตัวอักษรเป็น ${p.minCap} มม. ขึ้นไป`
      : `เส้นตัวอักษร ${p.chars.join(' ')} บางกว่าหัวฉีด 0.4 มม. — เพิ่มขนาดหรือเปลี่ยนฟอนต์หนา`,
    "bed-fit": p => `ป้ายกว้าง ${p.w.toFixed(0)} × ${p.h.toFixed(0)} มม. — อาจใหญ่กว่าฐานพิมพ์ 220 มม.`,
    "loop-float": () => 'ห่วงไม่ติดกับป้าย — ลองย้ายตำแหน่งห่วงหรือเพิ่มขอบฐาน',
    "thin-art": () => 'เส้นบางส่วนของรูปบางกว่าหัวฉีด 0.4 มม. — ขยายรูปหรือใช้รูปที่เส้นหนากว่า',
    "icon-max": (p) => `รูปใหญ่ได้ไม่เกิน ${p.max} มม. — แสดงที่ขนาดนี้`,
    "art-gone": () => ART_GONE,
    "base-pieces": () => BASE_PIECES,
  },
  errorCode: {
    "build-timeout": "สร้างแบบไม่เสร็จใน 2 นาที จึงเริ่มใหม่ — ลองลดตัวอักษรหรือเปลี่ยนฟอนต์",
    stale: "มีการเปลี่ยนแปลงใหม่กว่า",
    empty: "ไม่มีตัวอักษรให้พิมพ์",
    "font-load": "โหลดฟอนต์ไม่สำเร็จ",
    internal: "เกิดข้อผิดพลาด — ลองอีกครั้ง",
    "base-pieces": "ชิ้นส่วนบนป้ายอยู่ห่างกันเกินไป ฐานยึดไว้ไม่ได้ — เพิ่มขอบฐาน ลดระยะห่าง หรือย่อรูปให้เล็กลง",
    "art-gone": "รูปละเอียดเกินไปสำหรับขนาดนี้ — ขยายรูปให้ใหญ่ขึ้น",
    engine: "เกิดข้อผิดพลาด — ลองอีกครั้ง",
    fatal: "โหลดตัวสร้างโมเดลไม่สำเร็จ — รีเฟรชหน้า",
  },
  fatal: "โหลดตัวสร้างโมเดลไม่สำเร็จ — รีเฟรชหน้า",
  icon: "รูปหรือโลโก้ (SVG)",
  unpick: "เอารูปออก",
  iconPos: {
    left: "ซ้าย",
    right: "ขวา",
    above: "บน",
  },
  iconSize: "ขนาดรูป",
  iconGap: "ระยะห่าง",
  pct: (k) => `${Math.round(k * 100)}%`,
  needFile: "เลือกไฟล์ SVG ของรูปหรือโลโก้ — ไฟล์อยู่ในเครื่องของคุณ ไม่ถูกส่งไปที่ใด",
  artKept: "รูปอยู่ในหน้านี้เท่านั้น — รีเฟรชหน้าแล้วต้องเลือกไฟล์ใหม่",
  keptOld: "(ยังใช้รูปเดิมอยู่)",
  thumb: "ตัวอย่างรูปที่อ่านได้",
  shareNoIcon: "ลิงก์นี้ไม่มีไฟล์รูป — ผู้รับต้องเลือกไฟล์ SVG เอง",
  linkNeedsIcon: "แบบนี้ใช้รูปจากไฟล์ ซึ่งไม่ได้มากับลิงก์ — เลือกไฟล์ SVG เพื่อใส่รูป",

  // ship 3 piece c: the template's static text, baked per language by the build (was hardcoded Thai)
  aboutP: "ออกแบบป้ายชื่อหรือพวงกุญแจ 2–4 สี พิมพ์ชื่อภาษาไทย อังกฤษ จีน หรือญี่ปุ่น พิมพ์ได้หลายบรรทัดหรือแนวตั้ง เลือกฟอนต์ได้หลายแบบ แล้วดาวน์โหลดไฟล์ 3MF สำหรับเครื่องพิมพ์หลายสี หรือ STL สำหรับพิมพ์สีเดียว ใช้ฟรีในเบราว์เซอร์ ไม่ต้องติดตั้งโปรแกรม ใส่โลโก้หรือไอคอนจากไฟล์ SVG ไว้ข้างชื่อได้ — ไฟล์อยู่ในเครื่องของคุณ ไม่ถูกส่งไปที่ใด",
};
export default S;
